import { NavigationExtras } from '@angular/router';
import { createAction, props } from '@ngrx/store';

export const Go = createAction(
  '[Router] Go',
  props<{ path: any[]; query?: object; extras?: NavigationExtras }>(),
);

export const External = createAction('[Router] External', props<{ url: string }>());

export const Back = createAction('[Router] Back');
export const Forward = createAction('[Router] Forward');
export const Next = createAction('[Router] Next');
